import React from 'react'
import { format, formatDistanceToNow, formatDistance } from 'date-fns'

import Avatar from '../Avatar'
import CardTags from './CardTags'
import CardBlockTags from './CardBlockTags'
import Tags from 'components/Tags'
import StatusRenderer from '../GridList/renderers/StatusRenderer'
import ActionRenderer from '../GridList/renderers/ActionRenderer'
import BarRenderer from '../GridList/renderers/BarRenderer'
import GridList from '../GridList/GridList'
import InfoBox from '../InfoBox/InfoBox'
import BadgeInput from '../BadgeInput'
import CustomMultiSelect from '../Input/CustomMultiSelect'
import { TextInput } from '../../containers/CustomDashboard/Dashboard/details/editor/inputs/TextInput'
import { Select } from '../../containers/CustomDashboard/Dashboard/details/editor/inputs/Select'

export const renderCardContentType = (item, color) => {
  switch (item.type) {
    case 'action':
      return <ActionRenderer color={color} onClick={item.onClick} column={item.value} />
    case 'bar':
      return <BarRenderer color={color} onClick={item.onClick} column={item.value} />
    case 'tags':
      return item.value?.length > 0 ? <CardTags color={color} tags={item.value} /> : '-'
    case 'block-tags':
      return item.value?.length > 0 ? <CardBlockTags color={color} tags={item.value} /> : '-'
    case 'inputTags':
      return <Tags tagClass={color} tags={item.value} onChange={item.onChange} hideLabel />
    case 'inputText':
      return (
        <TextInput
          label={item.label}
          placeholder={item.placeholder}
          value={item.value}
          errorMessage={item.errorMessage}
          error={item.error}
          onChange={item.onChange}
          isDate={item.isDate}
          color={color}
        />
      )
    case 'inputSelect':
      return (
        <Select
          label={item.label}
          placeholder={item.placeholder}
          selectedOption={item.value}
          options={item.options}
          onChange={item.onChange}
        />
      )
    case 'customMultiSelect':
      return (
        <CustomMultiSelect
          value={item.value}
          color={item.color}
          parentClass={item.parentClass}
          onChange={item.onChange}
          options={item.options}
          label={item.label}
          rectangularTags={item.rectangularTags}
          borderInput={item.borderInput}
        />
      )
    case 'inputBadge':
      return (
        <BadgeInput
          key={item.values.length}
          label={item.label}
          values={item.values}
          color={color}
          onChange={item.onChange}
          isValid={item.isValid}
          errorMessage={item.errorMessage}
          helperText={item.helperText}
          showCount={item.showCount}
          hasError={item.hasError}
        />
      )
    case 'infoBox':
      return (
        <InfoBox {...item.componentProps} />
      )
    case 'timeElapse':
      return item.value ? formatDistanceToNow(new Date(item.value), { addSuffix: true }) : '-'
    case 'timeEta':
      return item.value ? formatDistance(new Date(item.value), new Date(), { addSuffix: true }) : '-'
    case 'avatar':
      return (
        <Avatar color={color} firstName={item.value?.firstName} lastName={item.value?.lastName} showName />
      )
    case 'status':
      return (
        item.value && <StatusRenderer color={color} name={item.value} colorMap={item.colorMap} def={item} />
      )
    case 'dateTime':
      return item.value ? format(new Date(item.value), 'd MMM yyyy HH:mm') : '-'
    case 'gridList':
      return <GridList gridData={item.gridData} gridDefs={item.gridDefs} gridProps={item.gridProps} />
    case 'capital':
      return <span className='type__value'>{item.value}</span>
    default:
      return item.value
  }
}